import React from "react";
import PropTypes from "prop-types";

/**
 * Tabs.List
 *  - Wrapper for list of TabMenu
 */
export function List(props) {
  return <div className={props.className}>{props.children}</div>;
}

List.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Chil components
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

List.defaultProps = {
  className: "",
};
